// extracted by css-extract-rspack-plugin
export default {"causesPortalLogo":"CausesPortalLogo_causesPortalLogo__gVq8h","causesPortalLogoCentralCard":"CausesPortalLogo_causesPortalLogoCentralCard__XHTSJ"};